module.exports = __webpack_public_path__ + "static/img/Ben-King.2bead13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ben-King.jpg
// module id = moN0
// module chunks = 0